export default __webpack_public_path__ + "static/08-da378d5fae6ba3a647c17b7685ded105.jpg";